import React from "react";
import { AnalyticsStatsCardWithSeparator } from "components/analytics/display-card-with-separator";
import { getBillableExtensionDays } from "@/lib/utils";

export function ExtendedStatCard({ billable }) {
  const extensionDays = getBillableExtensionDays(billable);

  const value = extensionDays !== null ? `${extensionDays} days` : "-";

  return (
    <AnalyticsStatsCardWithSeparator
      label="Extended"
      value={value}
      className="w-full max-w-full"
    />
  );
}
